import React from "react";
import { Box, Button, CircularProgress } from "@mui/material";

const ActionButtons = ({
  cancelLabel = "Cancel",
  actionLabel = "Submit",
  cancelHandler,
  actionHandler,
  isLoading,
  isActionDisabled,
  isCancelDisabled,
  mode = "submit", // "submit", "add", or "update"
  containerSx = { display: "flex", justifyContent: "flex-end", gap: 1 },
}) => {
  const getActionLabel = () => {
    if (mode === "add") return actionLabel || "Add";
    if (mode === "update") return actionLabel || "Update";
    return actionLabel || "Submit";
  };

  return (
    <Box sx={containerSx}>
      <Button
        variant="contained"
        color="error"
        onClick={cancelHandler}
        disabled={isCancelDisabled || isLoading}
      >
        {cancelLabel}
      </Button>
      <Button
        variant="contained"
        color="primary"
        onClick={actionHandler}
        disabled={isActionDisabled || isLoading}
        startIcon={isLoading ? <CircularProgress size={20} color="inherit" /> : null}
      >
        {getActionLabel()}
      </Button>
    </Box>
  );
};

export default ActionButtons;